import React, {useContext, useState} from 'react';
import { Loader2, LogOut } from "lucide-react";
import GedcomUploader from "./GedcomUploader";
import ForumMessages from "./ForumMessages";
import Announcements from "./Announcements";
import ProfileChanges from "./ProfileChanges";
import {FamilyContext} from "../Context/FamilyHeadContext";

export default function Admin() {
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('gedcom');
    const [submitStatus, setSubmitStatus] = useState(null);
    const [selectedFamily, setSelectedFamily] = useState('bazach');
    const { userDisconnection } = useContext(FamilyContext);

    return (
        <div className="max-w-7xl mx-auto p-6 bg-[#f8f5f1] min-h-screen">
            <div className="mb-12">
                <h1 className="text-3xl font-heebo font-bold text-[#937c5d] mb-4 relative
                   after:content-[''] after:absolute after:-bottom-2 after:right-0
                   after:w-24 after:h-1 after:bg-[#c9a66c] after:rounded-full">
                    פאנל ניהול
                </h1>
                <button
                    onClick={userDisconnection}
                    className="flex items-center gap-2 px-4 py-2 bg-[#937c5d] text-white rounded-lg
                    hover:bg-[#c9a66c] transition-colors duration-200 font-heebo"
                    dir="rtl"
                >
                    <LogOut size={18}/>
                    <span>התנתקות</span>
                </button>
            </div>

            {/* Family Selector */}
            <div className="mb-8" dir="rtl">
                <div className="inline-flex bg-white rounded-xl p-1 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
                    <button
                        onClick={() => setSelectedFamily('bazach')}
                        className={`px-6 py-3 rounded-lg font-heebo transition-all ${
                            selectedFamily === 'bazach'
                                ? 'bg-gradient-to-r from-[#937c5d] to-[#c9a66c] text-white'
                                : 'text-[#937c5d] hover:bg-[#f8f5f1]'
                        }`}
                    >
                        משפחת בזך
                    </button>
                    <button
                        onClick={() => setSelectedFamily('huminer')}
                        className={`px-6 py-3 rounded-lg font-heebo transition-all ${
                            selectedFamily === 'huminer'
                                ? 'bg-gradient-to-r from-[#937c5d] to-[#c9a66c] text-white'
                                : 'text-[#937c5d] hover:bg-[#f8f5f1]'
                        }`}
                    >
                        משפחת הומינר
                    </button>
                </div>
            </div>

            {/* Custom Tabs */}
            <div className="mb-8" dir="rtl">
                <div className="inline-flex bg-white rounded-xl p-1 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
                    <button
                        onClick={() => setActiveTab('gedcom')}
                        className={`px-6 py-3 rounded-lg font-heebo transition-all ${
                            activeTab === 'gedcom'
                                ? 'bg-gradient-to-r from-[#937c5d] to-[#c9a66c] text-white'
                                : 'text-[#937c5d] hover:bg-[#f8f5f1]'
                        }`}
                    >
                        טיפול בGEDCOM
                    </button>
                    <button
                        onClick={() => setActiveTab('messages')}
                        className={`px-6 py-3 rounded-lg font-heebo transition-all ${
                            activeTab === 'messages'
                                ? 'bg-gradient-to-r from-[#937c5d] to-[#c9a66c] text-white'
                                : 'text-[#937c5d] hover:bg-[#f8f5f1]'
                        }`}
                    >
                        ניהול הודעות פורום
                    </button>
                    <button
                        onClick={() => setActiveTab('announcements')}
                        className={`px-6 py-3 rounded-lg font-heebo transition-all ${
                            activeTab === 'announcements'
                                ? 'bg-gradient-to-r from-[#937c5d] to-[#c9a66c] text-white'
                                : 'text-[#937c5d] hover:bg-[#f8f5f1]'
                        }`}
                    >
                        הודעות מנהל באתר
                    </button>
                    <button
                        onClick={() => setActiveTab('profile-changes')}
                        className={`px-6 py-3 rounded-lg font-heebo transition-all ${
                            activeTab === 'profile-changes'
                                ? 'bg-gradient-to-r from-[#937c5d] to-[#c9a66c] text-white'
                                : 'text-[#937c5d] hover:bg-[#f8f5f1]'
                        }`}
                    >
                        שינויי פרופיל
                    </button>
                </div>
            </div>

            {/* Tab Contents */}
            {activeTab === 'gedcom' && <GedcomUploader selectedFamily={selectedFamily} setIsLoading={setIsLoading} />}
            {activeTab === 'messages' && <ForumMessages selectedFamily={selectedFamily} setSubmitStatus={setSubmitStatus} />}
            {activeTab === 'announcements' && <Announcements selectedFamily={selectedFamily} setSubmitStatus={setSubmitStatus} />}
            {activeTab === 'profile-changes' && <ProfileChanges selectedFamily={selectedFamily} setSubmitStatus={setSubmitStatus} />}

            {/* Loading Overlay */}
            {isLoading && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center gap-4">
                        <Loader2 className="w-12 h-12 animate-spin text-[#937c5d]" />
                        <p className="text-[#4a3f30] font-heebo">מעבד את הקובץ...</p>
                    </div>
                </div>
            )}

            {/* Status Messages */}
            {submitStatus && (
                <div className={`mt-4 p-4 rounded-xl font-heebo ${
                    submitStatus.type === 'success'
                        ? 'bg-green-50 text-green-600 border border-green-200'
                        : 'bg-red-50 text-red-600 border border-red-200'
                }`}>
                    {submitStatus.message}
                </div>
            )}
        </div>
    );
}